import {
  DropDown,
  SearchBar,
  NewSiteButton,
  Card,
} from "../components/textField";
import TopNav from "../components/topnav";
import { useState, useEffect, useMemo } from "react";
import { content } from "../utils/data";
import EnhancedTable from "../components/newTable";
import SiteTabs from "../components/tabs";
import {
  getDocumentsRejected,
  getDocumentsApproved,
  getDocumentsPending,
  approvedRejected,
  getStatesDropDown,
  getSiteDropDown,
  getLocationDropDown,
  getBorrowals,
  getTranslationFile,
  decideTranslation,
  decideSummary,
} from "../api/serverApi";
import SummaryModal from "../components/approvalSummaryModal";
import TranslationModal from "../components/approvalTranslationModal";
import Approve from "../assests/approve.png";
import Reject from "../assests/reject.png";
import Modal from "../components/modal";
import DocumentModal from "../components/documentModal";
import Spinner from "../components/spinner";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import StatusModal from "../components/statusModal";
import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import { useCookies } from "react-cookie";
import * as microsoftTeams from "@microsoft/teams-js";
import { useBackgroundAIJobs } from "../components/backgroundAIJobContext";

const Approval = () => {
  const {
    translationJobs,
    startTranslationJob,
    clearTranslationJob,

    summaryJobs,
    startSummaryJob,
    clearSummaryJob,
  } = useBackgroundAIJobs();


  const [open, setOpen] = useState(false);
  const [rejected, getRejeceted] = useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [approved, getApproved] = useState([]);
  const [pending, getPending] = useState([]);
  const [pendingRows, setPendingRows] = useState(pending || []);
  const [showModal, setShowModal] = useState(false);
  const [selectedApprovalId, setSelectedApprovalId] = useState(null);
  const [reason, setReason] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [getState, setGetState] = useState([]);
  const [getLocation, setGetLocation] = useState([]);
  const [getSite, setGetSite] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedSiteId, setSelecteSiteId] = useState("");
  const [borrowal, setBorrowal] = useState([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { instance, accounts } = useMsal();
  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);

  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const [translationOpen, setTranslationOpen] = useState(false);

  const [translationPreviewUrl, setTranslationPreviewUrl] = useState("");
  const [existingTranslationPreviewUrl, setExistingTranslationPreviewUrl] =
    useState("");

  const [summaryOpen, setSummaryOpen] = useState(false);

  const [summaryResponse, setSummaryResponse] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchRejectedDocuments = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getDocumentsRejected(token);
        getRejeceted(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedDocuments();
  }, []);

  useEffect(() => {
    const fetchApprovedDocuments = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getDocumentsApproved(token);
        getApproved(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedDocuments();
  }, []);

  useEffect(() => {
    const fetchPendingDocuments = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getDocumentsPending(token);
        console.log("Pending Documents:", response.data);
        getPending(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingDocuments();
  }, []);

  useEffect(() => {
    const fetchBorrowals = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getBorrowals(token);

        setBorrowal(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBorrowals();
  }, []);

  const rowsRejected = useMemo(() => {
    return (rejected || [])
      .filter(({ document_name, state_name, location_name, site_name }) =>
        [document_name, state_name, location_name, site_name].some((field) =>
          String(field || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
        ),
      )
      .map(
        ({
          approval_id,
          sharepoint_id,
          document_name,
          approved_rejected_at,
          state_name,
          location_name,
          site_name,
          document_type,
          document_copy_type,
          document_category,
          os_number,
          box_number,
          start_year,
          end_year,
          valid_until,
          saledeed_no,
          seller_name,
          receipt_number,
          khata,
          amount,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          parent_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          unique_survey_no,
          building_code,
          entity_name,
          site_id,
          state_id,
          url,
          loction_id,
          lease_deed_date,
          lease_no,
          purchase_date,
        }) => {
          const formattedDate = approved_rejected_at
            ? new Date(approved_rejected_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            key: approval_id,
            approved_rejected_at: formattedDate,
            state_name,
            sharepoint_id,
            location_name,
            start_year,
            end_year,
            valid_until,
            saledeed_no,
            seller_name,
            receipt_number,
            khata,
            amount,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,

            parent_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            site_id,
            state_id,
            loction_id,
            site_name,
            url,
            lease_deed_date,
            lease_no,
            purchase_date,
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    approval_id,
                    sharepoint_id,
                    document_name,
                    approved_rejected_at: formattedDate,
                    state_name,
                    location_name,
                    start_year,
                    end_year,
                    valid_until,
                    saledeed_no,
                    seller_name,
                    receipt_number,
                    khata,
                    amount,
                    other_document_title,
                    other_document_description,
                    reference_document_title,
                    reference_document_description,

                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,

                    parent_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    site_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    os_number,
                    url,
                    box_number,
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    building_code,
                    entity_name,
                    lease_deed_date,
                    lease_no,
                    purchase_date,
                  });
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),
          };
        },
      );
  }, [rejected, searchTerm]);

  const filteredRowsRejected = rowsRejected.filter((row) => {
    const matchState = selectedStateId
      ? row.state_id === selectedStateId
      : true;
    const matchLocation = selectedLocationId
      ? row.loction_id === selectedLocationId
      : true;
    const matchSite = selectedSiteId ? row.site_id === selectedSiteId : true;
    return matchState && matchLocation && matchSite;
  });

  const rowsApproved = useMemo(() => {
    return (approved || [])
      .filter(({ document_name, state_name, location_name, site_name }) =>
        [document_name, state_name, location_name, site_name].some((field) =>
          String(field || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
        ),
      )
      .map(
        ({
          approval_id,
          sharepoint_id,
          document_name,
          loction_id,
          state_id,
          site_id,
          approved_rejected_at,
          state_name,
          location_name,
          site_name,
          cnr_number,
          document_type,
          document_copy_type,
          document_category,
          building_code,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          seller_name,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          parent_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          os_number,
          box_number,
          url,
          unique_survey_no,
          entity_name,
          lease_deed_date,
          lease_no,
          uploaded_by,
          purchase_date,
          translation_accepted,
          summary_accepted,
        }) => {
          const formattedDate = approved_rejected_at
            ? new Date(approved_rejected_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            key: approval_id,
            sharepoint_id,
            approved_rejected_at: formattedDate,
            state_name,
            location_name,
            loction_id,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            saledeed_no,
            seller_name,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,

            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,

            parent_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            state_id,
            site_id,
            site_name,
            url,
            lease_deed_date,
            lease_no,
            purchase_date,
            uploaded_by,

            // NEW
            translation_accepted: Boolean(translation_accepted),
            summary_accepted: Boolean(summary_accepted),
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    approval_id,
                    sharepoint_id,
                    cnr_number,
                    document_name,
                    approved_rejected_at: formattedDate,
                    state_name,
                    location_name,
                    site_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    start_year,
                    end_year,
                    valid_until,
                    receipt_number,
                    khata,
                    amount,
                    saledeed_no,
                    seller_name,
                    other_document_title,
                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,

                    parent_document_description,
                    reference_document_title,
                    reference_document_description,
                    other_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    os_number,
                    box_number,
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    url,
                    building_code,
                    lease_deed_date,
                    lease_no,
                    purchase_date,
                    entity_name,
                    uploaded_by,
                  });
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),
          };
        },
      );
  }, [approved, searchTerm]);

  const filteredRowsApproved = rowsApproved.filter((row) => {
    const matchState = selectedStateId
      ? row.state_id === selectedStateId
      : true;
    const matchLocation = selectedLocationId
      ? row.loction_id === selectedLocationId
      : true;
    const matchSite = selectedSiteId ? row.site_id === selectedSiteId : true;
    return matchState && matchLocation && matchSite;
  });

  const rowsPending = useMemo(() => {
    return (pending || [])
      .filter(
        ({
          document_name,
          state_name,
          location_name,
          site_name,
          document_type,
          document_copy_type,
          document_category,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,

          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          cnr_number,
          parent_document_description,
          os_number,
          box_number,
          unique_survey_no,
          building_code,
          entity_name,
          uploaded_by,
        }) =>
          [
            document_name,
            state_name,
            location_name,
            site_name,
            document_type,
            document_copy_type,
            document_category,
            os_number,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            saledeed_no,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,
            cnr_number,
            parent_document_description,
            box_number,
            unique_survey_no,
            building_code,
            entity_name,
            uploaded_by,
          ].some((field) =>
            String(field || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()),
          ),
      )
      .map(
        ({
          approval_id,
          document_id,
          state_name,
          location_name,
          sharepoint_id,
          site_name,
          document_name,
          uploaded_at,
          document_type,
          loction_id,
          state_id,
          site_id,
          document_copy_type,
          document_category,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          seller_name,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          cnr_number,
          parent_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          os_number,
          box_number,
          url,
          unique_survey_no,
          building_code,
          lease_deed_date,
          lease_no,
          purchase_date,
          entity_name,
          uploaded_by,
          translation_accepted,
          summary_accepted,
        }) => {
          const formattedDate = uploaded_at
            ? new Date(uploaded_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            key: approval_id,
            loction_id,
            state_id,
            site_id,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            url,
            saledeed_no,
            seller_name,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,
            cnr_number,

            parent_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            lease_deed_date,
            lease_no,
            purchase_date,
            uploaded_by,
            translation_accepted: Boolean(translation_accepted),
            summary_accepted: Boolean(summary_accepted),
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    approval_id,
                    sharepoint_id,
                    document_name,
                    approved_rejected_at: formattedDate,
                    state_name,
                    location_name,
                    start_year,
                    end_year,
                    valid_until,
                    receipt_number,
                    khata,
                    amount,
                    saledeed_no,
                    seller_name,
                    other_document_title,
                    other_document_description,
                    reference_document_title,
                    reference_document_description,
                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,
                    cnr_number,
                    parent_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    site_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    os_number,
                    box_number,

                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    building_code,
                    url,
                    lease_deed_date,
                    lease_no,
                    purchase_date,
                    entity_name,
                  });
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),
            uploaded_at: formattedDate,
            state_name,
            location_name,
            site_name,
            sharepoint_id,
            actions: (
              <div className="flex">
                {/* Translate */}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor:
                      translationJobs[document_id]?.status === "done"
                        ? "#bfd69f"
                        : "#abd0e0",
                    color: "black",
                    ml: 1,
                    textTransform: "none",
                    borderRadius: "15px",
                    minWidth: "110px",
                    height: "40px",
                    boxShadow: "none",
                  }}
                  disabled={
                    translationJobs[document_id]?.status === "processing"
                  }
                  onClick={async () => {
                    const job = translationJobs[document_id];

                    console.log("========== TRANSLATE CLICK ==========");
                    console.log("Document ID:", document_id);
                    console.log("translation_accepted:", translation_accepted);
                    console.log("translation job:", job);

                    // =====================================================
                    // 1. CURRENT SESSION TRANSLATION IS DONE
                    // Open newly generated translation preview
                    // =====================================================

                    if (job?.status === "done") {
                      console.log("CURRENT TRANSLATION DONE → OPENING PREVIEW");

                      setSelectedDocumentId(document_id);

                      setTranslationPreviewUrl(job.download_url || "");

                      setExistingTranslationPreviewUrl("");

                      setTranslationOpen(true);

                      return;
                    }

                    // =====================================================
                    // 2. TRANSLATION WAS ALREADY ACCEPTED
                    // Fetch the already saved translation
                    // =====================================================

                    if (translation_accepted === true) {
                      try {
                        console.log(
                          "TRANSLATION ACCEPTED → FETCHING EXISTING TRANSLATION",
                        );

                        let token;

                        if (isInTeams()) {
                          token = await new Promise((resolve, reject) => {
                            microsoftTeams.authentication.getAuthToken({
                              successCallback: resolve,
                              failureCallback: reject,
                              resources: ["https://graph.microsoft.com"],
                            });
                          });
                        } else {
                          token = await getValidAccessToken(instance, accounts);
                        }

                    const response = await getTranslationFile(
  document_id,
  token
);

console.log(
  "========== EXISTING TRANSLATION FILE RESPONSE =========="
);

console.log("FULL RESPONSE:", response);

console.log(
  "CONTENT TYPE:",
  response?.headers?.["content-type"]
);

// Convert PDF Blob into a browser URL
if (existingTranslationPreviewUrl) {
  URL.revokeObjectURL(
    existingTranslationPreviewUrl
  );
}

const existingUrl = URL.createObjectURL(
  response.data
);

console.log(
  "EXISTING TRANSLATION BLOB URL:",
  existingUrl
);

                        

                        setSelectedDocumentId(document_id);

                        // There is NO newly generated translation
                        setTranslationPreviewUrl("");

                        // Existing accepted translation
                        setExistingTranslationPreviewUrl(existingUrl);

                        // Open TranslationModal
                        setTranslationOpen(true);

                        return;
                      } catch (error) {
                        console.error(
                          "Failed to get existing translation:",
                          error,
                        );

                        const message =
                          error?.response?.data?.detail ||
                          error?.response?.data?.error ||
                          error?.message ||
                          "Failed to load existing translation.";

                        setResponseMessage(message);
                        setIsSuccess(false);
                        setisModalOpen(true);

                        return;
                      }
                    }

                    // =====================================================
                    // 3. FIRST TIME / REJECTED
                    // DO NOT CALL GET TRANSLATION
                    // Directly generate
                    // =====================================================

                    console.log(
                      "NO ACCEPTED TRANSLATION → STARTING NEW TRANSLATION",
                    );

                    handleTranslate(document_id);
                  }}
                >
                  {translationJobs[document_id]?.status === "processing"
                    ? "Translating..."
                    : translationJobs[document_id]?.status === "done"
                      ? "Preview Translate"
                      : translationJobs[document_id]?.status === "failed"
                        ? "Retry Translate"
                        : "Translate"}
                </Button>

                {/* Summary */}
                {/* Summary */}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor:
                      summaryJobs[document_id]?.status === "done"
                        ? "#bfd69f"
                        : "#eeb568",
                    color: "black",
                    ml: 1,
                    textTransform: "none",
                    borderRadius: "15px",
                    minWidth: "110px",
                    height: "40px",
                    boxShadow: "none",
                  }}
                  disabled={summaryJobs[document_id]?.status === "processing"}
                onClick={async () => {
  const job = summaryJobs[document_id];

  console.log("========== SUMMARY CLICK ==========");
  console.log("Document ID:", document_id);
  console.log("summary_accepted:", summary_accepted);
  console.log("summary job:", job);

  // =====================================================
  // 1. CURRENT SESSION SUMMARY IS DONE
  // → OPEN NEWLY GENERATED SUMMARY
  // =====================================================

  if (job?.status === "done") {
    console.log(
      "CURRENT SUMMARY DONE → OPENING PREVIEW"
    );

    setSelectedDocumentId(document_id);
    setSummaryResponse(job.result || null);
    setSummaryOpen(true);

    return;
  }

  // =====================================================
  // 2. SUMMARY WAS ALREADY ACCEPTED
  // → SHOW RE-SUMMARY CONFIRMATION
  // =====================================================

if (summary_accepted === true) {
  console.log(
    "SUMMARY ACCEPTED → OPENING SUMMARY MODAL"
  );

  setSelectedDocumentId(document_id);
  setSummaryResponse(null);
  setSummaryOpen(true);

  return;
}

  // =====================================================
  // 3. FIRST TIME / REJECTED
  // → START NEW SUMMARY
  // =====================================================

  console.log(
    "NO ACCEPTED SUMMARY → STARTING NEW SUMMARY"
  );

  handleSummary(document_id);
}}
                >
                  {summaryJobs[document_id]?.status === "processing"
                    ? "Summarizing..."
                    : summaryJobs[document_id]?.status === "done"
                      ? "Preview Summary"
                      : summaryJobs[document_id]?.status === "failed"
                        ? "Retry Summary"
                        : "Summary"}
                </Button>

                {/* Approve */}
                <img
                  src={Approve}
                  alt="Approve"
                  style={{
                    width: "80px",
                    height: "40px",
                    cursor: "pointer",
                    marginRight: "10px",
                    marginLeft: "10px",
                  }}
                  onClick={() => handleApprove(approval_id)}
                />

                {/* Reject */}
                <img
                  src={Reject}
                  alt="Reject"
                  style={{
                    width: "70px",
                    height: "40px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    setSelectedApprovalId(approval_id);
                    setShowModal(true);
                  }}
                />
              </div>
            ),
          };
        },
      );
  }, [pending, searchTerm, translationJobs, summaryJobs]);

  const filteredRowsPending = rowsPending.filter((row) => {
    const matchState = selectedStateId
      ? row.state_id === selectedStateId
      : true;
    const matchLocation = selectedLocationId
      ? row.loction_id === selectedLocationId
      : true;
    const matchSite = selectedSiteId ? row.site_id === selectedSiteId : true;
    return matchState && matchLocation && matchSite;
  });

  const rowsBorrowed = useMemo(() => {
    return (borrowal || [])
      .filter(
        ({
          document_name,
          status,
          borrowal_date,
          borrowed_user,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          other_document_title,
          other_document_description,
          os_number,
          box_number,
          unique_survey_no,
          building_code,
          entity_name,
          site_id,
          state_id,
          location_id,
          site_name,
          state_name,
          location_name,
          document_type,
          document_copy_type,
          document_category,
        }) =>
          [document_name, status, borrowal_date, borrowed_user].some((field) =>
            String(field || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()),
          ),
      )
      .map(
        ({
          document_name,
          status,
          borrowal_date,
          borrowed_user,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          seller_name,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,

          parent_document_description,
          os_number,
          box_number,
          unique_survey_no,
          building_code,
          entity_name,
          site_id,
          state_id,
          location_id,
          site_name,
          state_name,
          location_name,
          document_type,
          document_copy_type,
          document_category,
        }) => {
          const formattedDate = borrowal_date
            ? new Date(borrowal_date)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            document_name,
            status,
            borrowal_date: formattedDate,
            borrowed_user,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            saledeed_no,
            seller_name,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,

            parent_document_description,
            os_number,
            box_number,
            unique_survey_no,
            building_code,
            entity_name,
            site_id,
            state_id,
            location_id,
            site_name,
            state_name,
            location_name,
            document_type,
            document_copy_type,
            document_category,
          };
        },
      );
  }, [borrowal, searchTerm]);

  const handleApprove = async (approval_id) => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const data = {
        approval_id,
        decision: "Approved",
      };

      await approvedRejected(approval_id, data, token);

      const [pendingRes, approvedRes, rejectedRes] = await Promise.all([
        getDocumentsPending(token),
        getDocumentsApproved(token),
        getDocumentsRejected(token),
      ]);

      getPending(pendingRes.data);
      getApproved(approvedRes.data);
      getRejeceted(rejectedRes.data);

      setResponseMessage("Document approved successfully.");
      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Approve failed:", error);

      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);
      setisModalOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleRejectConfirm = async () => {
    setLoading(true);

    const data = {
      approval: selectedApprovalId,
      decision: "Rejected",
      reason: reason,
    };

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      await approvedRejected(selectedApprovalId, data, token);

      const [pendingRes, approvedRes, rejectedRes] = await Promise.all([
        getDocumentsPending(token),
        getDocumentsApproved(token),
        getDocumentsRejected(token),
      ]);

      getPending(pendingRes.data);
      getApproved(approvedRes.data);
      getRejeceted(rejectedRes.data);

      setResponseMessage("Document rejected successfully.");
      setIsSuccess(true);
      setisModalOpen(true);

      setShowModal(false);
      setSelectedApprovalId(null);
      setOpen(false);
      resetForm();
    } catch (error) {
      console.error("Reject API error:", error);

      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);
      setisModalOpen(true);
      setShowModal(false);
      setSelectedApprovalId(null);
      setOpen(false);
      resetForm();
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setReason("");
  };



  // --------------------------end of summary button to check if the summary same id

  const handleTranslate = async (documentId) => {
    try {
      /*
       * Prevent duplicate translation jobs.
       */

      if (translationJobs[documentId]?.status === "processing") {
        return;
      }

      console.log("Starting background translation:", documentId);

      await startTranslationJob(documentId);

      setResponseMessage(
        "Translation started successfully. You can continue working.",
      );

      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Failed to start translation:", error);

      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to start translation.";

      setResponseMessage(message);
      setIsSuccess(false);
      setisModalOpen(true);
    }
  };
  const handleSummary = async (documentId) => {
    try {
      if (summaryJobs[documentId]?.status === "processing") {
        return;
      }

      console.log("Starting background summary:", documentId);

      await startSummaryJob(documentId);

      setResponseMessage(
        "Summary started successfully. You can continue working.",
      );

      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Failed to start summary:", error);

      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to start summary.";

      setResponseMessage(message);
      setIsSuccess(false);
      setisModalOpen(true);
    }
  };

  const handleAcceptTranslation = () => handleTranslationDecision("Accept");

  const handleRejectTranslation = () => handleTranslationDecision("Reject");

  const handleTranslationDecision = async (decision) => {
    // IMPORTANT: save ID before changing state
    const documentId = selectedDocumentId;

    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const data = {
        decision,
      };

      if (decision === "Accept") {
        data.download_url = translationPreviewUrl;
      }

      console.log("Translation Decision:", data);

      // ============================================
      // CLOSE UI IMMEDIATELY
      // ============================================

      setTranslationOpen(false);
      setTranslationPreviewUrl("");
      setSelectedDocumentId(null);

      // Change button from "Preview Translate"
      // back to "Translate" immediately
      clearTranslationJob(documentId);

      // ============================================
      // CALL API AFTER UI IS CLOSED
      // ============================================

      const response = await decideTranslation(documentId, data, token);

      console.log("Translation Decision Response:", response.data);
      // ============================================
      // REFRESH PENDING DOCUMENTS
      // ============================================

      const pendingRes = await getDocumentsPending(token);

      getPending(pendingRes.data);
    } catch (error) {
      console.error("Translation decision failed:", error);

      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message ||
        `Failed to ${decision === "Accept" ? "accept" : "reject"} translation.`;

      setResponseMessage(message);
      setIsSuccess(false);
      setisModalOpen(true);
    }
  };
  const handleDecision = async (type, decision) => {
    // Store document ID before clearing state
    const documentId = selectedDocumentId;

    try {
      let token;

      // =========================================================
      // GET ACCESS TOKEN
      // =========================================================
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      // =========================================================
      // SUMMARY DECISION
      // =========================================================
      if (type === "summary") {
        // -------------------------------------------------------
        // Get download URL from completed summary job
        // -------------------------------------------------------
        const downloadUrl =
          summaryJobs?.[documentId]?.result?.download_url ||
          summaryResponse?.download_url ||
          "";

        console.log("Summary Document ID:", documentId);

        console.log("Summary Decision:", decision);

        console.log("Summary Download URL:", downloadUrl);

        // -------------------------------------------------------
        // Prepare request data
        // -------------------------------------------------------
        const data = {
          decision,
        };

        // -------------------------------------------------------
        // Backend requires download_url ONLY for Accept
        // -------------------------------------------------------
        if (decision === "Accept") {
          if (!downloadUrl) {
            throw new Error(
              "Summary download URL is not available. Please try generating the summary again.",
            );
          }

          data.download_url = downloadUrl;
        }

        console.log("Summary Decision Request:", data);

        // =======================================================
        // CALL API
        // =======================================================
        const response = await decideSummary(documentId, data, token);

        console.log("Summary Decision Response:", response.data);

        // =======================================================
        // CLOSE SUMMARY MODAL
        // =======================================================
        setSummaryOpen(false);

        // =======================================================
        // CLEAR SELECTED DOCUMENT
        // =======================================================
        setSelectedDocumentId(null);

        // =======================================================
        // CLEAR SUMMARY RESPONSE
        // =======================================================
        setSummaryResponse(null);

        // =======================================================
        // CLEAR BACKGROUND SUMMARY JOB
        // =======================================================
        clearSummaryJob(documentId);

        // =======================================================
        // SUCCESS MESSAGE
        // =======================================================
        setResponseMessage(
          response.data?.message ||
            `Summary ${
              decision === "Accept" ? "accepted" : "rejected"
            } successfully.`,
        );

        setIsSuccess(true);
        setisModalOpen(true);

        // =======================================================
        // RELOAD PAGE
        // =======================================================
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      }
    } catch (error) {
      console.error("Summary decision failed:", error);

      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message ||
        `Failed to ${decision === "Accept" ? "accept" : "reject"} summary.`;

      setResponseMessage(message);

      setIsSuccess(false);

      setisModalOpen(true);
    }
  };

  const handleAcceptSummary = () => handleDecision("summary", "Accept");

  const handleRejectSummary = () => handleDecision("summary", "Reject");
  // states start
  useEffect(() => {
    // setLoading(true);
    getStatesDropDown(cookies.accessToken)
      .then((response) => {
        // Handle successful response
        setGetState(response.data);
        console.log(response);

        setSelectedLocationId("");
        setSelecteSiteId("");

        // setLoading(false);
      })
      .catch((error) => {
        // Handle error
        // setshowModal(true);
        // setModalTitle("Something went wrong, Please try again");
        console.error("Error:", error);

        // setLoading(false);
      });
  }, []);

  // states end
  // location start

  useEffect(() => {
    if (selectedStateId) {
      getLocationDropDown({ state_id: selectedStateId }, cookies.accessToken)
        .then((response) => {
          setGetLocation(response.data);
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      setGetLocation([]);
      setSelectedLocationId("");
      setSelecteSiteId("");
    }
  }, [selectedStateId]);
  // location end
  useEffect(() => {
    if (selectedLocationId) {
      getSiteDropDown({ location_id: selectedLocationId }, cookies.accessToken)
        .then((response) => {
          setGetSite(response.data);
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      setGetSite([]);
      setSelecteSiteId("");
    }
  }, [selectedLocationId]);
  return (
    <>
      <div>
        <TopNav />
      </div>
      <div></div>
      <div className="px-[35px] py-2 font-bold text-2xl">Approval</div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="State"
            placeholder="None"
            responseData={getState}
            labelKey="name"
            valueKey="state_id"
            onChange={(e) => setSelectedStateId(Number(e.target.value))}
            value={selectedStateId}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Location"
            placeholder="None"
            responseData={getLocation}
            labelKey="name"
            valueKey="location_id"
            onChange={(e) => setSelectedLocationId(Number(e.target.value))}
            value={selectedLocationId}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Site"
            placeholder="None"
            responseData={getSite}
            labelKey="name"
            valueKey="site_id"
            onChange={(e) => setSelecteSiteId(Number(e.target.value))}
            value={selectedSiteId}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setSelectedStateId(null);
              setSelectedLocationId(null);
              setSelecteSiteId(null);
              setSearchTerm("");
            }}
            sx={{
              backgroundColor: "#1381B5",
              "&:hover": { backgroundColor: "#0f6c99" },
              width: "95px",
              height: "40px",
              fontSize: "10px",
              whiteSpace: "nowrap", // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>
      </div>
      <div className="py-2">
        <SiteTabs
          Pending={
            <>
              <EnhancedTable
                rows={filteredRowsPending}
                header={content.pending}
                height="375px"
              />
              <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                label="Are you sure you want to reject?"
                subheading="Reason For Rejection*"
                showTextBox={true}
                reason={reason}
                setReason={setReason}
                primaryButton={
                  <button
                    onClick={handleRejectConfirm}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Reject
                  </button>
                }
                secondaryButton={
                  <button
                    onClick={() => setShowModal(false)}
                    style={{
                      backgroundColor: "gray",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                }
              />
            </>
          }
          Approval={
            <EnhancedTable
              rows={filteredRowsApproved}
              header={content.approved}
              height="375px"
            />
          }
          Rejected={
            <EnhancedTable
              rows={filteredRowsRejected}
              header={content.rejected}
              height="375px"
            />
          }
          Borrowal={
            <EnhancedTable
              rows={rowsBorrowed}
              header={content.borrowed}
              height="375px"
            />
          }
        />
        <DocumentModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          metadata={selectedMetadata}
          metadataFields={[
            { key: "document_name", label: "File Name" },
            { key: "state_name", label: "State" },
            { key: "location_name", label: "Location" },
            { key: "site_name", label: "Site" },
            { key: "uploaded_at", label: "Upload Date" },
            { key: "box_number", label: "Box No" },
            { key: "unique_survey_no", label: "Survey No" },
            { key: "os_number", label: "OS Number" },
            { key: "cnr_number", label: "CNR Number" },
            { key: "document_category", label: "Document Category" },
            { key: "document_copy_type", label: "Document Classification" },
            { key: "entity_name", label: "Entity" },
            { key: "building_name", label: "Building Name" },
            { key: "saledeed_no", label: "Sale Deed No" },
            { key: "seller_name", label: "Seller Name" },
            { key: "purchase_date", label: "Purchase Date" },
            { key: "lease_deed_date", label: "Lease Deed Date" },
            { key: "lease_no", label: "Lease No" },
            { key: "start_year", label: "Start Year" },
            { key: "end_year", label: "End Year" },
            { key: "valid_until", label: "Valid Until" },
            { key: "receipt_number", label: "Receipt Number" },
            { key: "khata", label: "Khata" },
            { key: "amount", label: "Amount(Rs.)" },
            { key: "other_document_title", label: "Other Document Title" },
            {
              key: "other_document_description",
              label: "Other Document Description",
            },
            {
              key: "reference_document_title",
              label: "Reference Document Title",
            },
            {
              key: "reference_document_description",
              label: "Reference Document Description",
            },

            {
              key: "grand_parent_document_title",
              label: "Grand Parent Document Title",
            },
            {
              key: "grand_parent_document_description",
              label: "Grand Parent Document Description",
            },
            {
              key: "parent_document_title",
              label: "Parent Document Title",
            },
            {
              key: "parent_document_description",
              label: "Parent Document Description",
            },
          ]}
        />
        ;
      </div>
   

      {/* =====================================================
          RE-TRANSLATION CONFIRMATION
      ====================================================== */}

  

      {/* =====================================================
          TRANSLATION MODAL
      ====================================================== */}

      <TranslationModal
        open={translationOpen}
   onClose={() => {
  if (existingTranslationPreviewUrl) {
    URL.revokeObjectURL(
      existingTranslationPreviewUrl
    );
  }

  setTranslationOpen(false);
  setSelectedDocumentId(null);
  setTranslationPreviewUrl("");
  setExistingTranslationPreviewUrl("");
}}
        previewUrl={translationPreviewUrl}
        translationAccepted={
          pending.find((item) => item.document_id === selectedDocumentId)
            ?.translation_accepted === true &&
          translationJobs[selectedDocumentId]?.status !== "done"
        }
        existingTranslationPreviewUrl={existingTranslationPreviewUrl}
        onRetranslate={() => {
          if (selectedDocumentId) {
            handleTranslate(selectedDocumentId);
          }
        }}
        onAccept={handleAcceptTranslation}
        onReject={handleRejectTranslation}
      />

      {/* =====================================================
    RE-SUMMARY CONFIRMATION
====================================================== */}


<SummaryModal
  open={summaryOpen}
  onClose={() => {
    setSummaryOpen(false);
    setSelectedDocumentId(null);
    setSummaryResponse(null);
  }}
  onAccept={handleAcceptSummary}
  onReject={handleRejectSummary}
  summaryResponse={summaryResponse}
  documentId={selectedDocumentId}
  accessToken={cookies.accessToken}

  // NEW
  summaryAccepted={
    pending.find(
      (item) => item.document_id === selectedDocumentId
    )?.summary_accepted === true &&
    summaryJobs[selectedDocumentId]?.status !== "done"
  }

  // NEW
  onResummarize={(documentId) => {
    handleSummary(documentId);
  }}
/>

      {loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => setisModalOpen(false)}
        message={responseMessage}
        isSuccess={isSuccess}
      />
    </>
  );
};

export default Approval;
